import React from 'react';
import classes from './PrivacyContent.module.scss';

export const PrivacyContent = () => {
    return (
        <div className={`${classes['content-wrapper']}`}>
            <div className={`${classes['title']}`}>Privacy Policy</div>
            <p className="text-center"><strong>LEGAL</strong></p>
            <p className="text-center"><strong>PRIVACY POLICY</strong></p>
            <p>This is the privacy policy (<b>"Privacy Policy”</b>) of Fundever Market
                Solutions Inc.
                (<b>“Fundever”,
                    "we", "our",</b> or <b>"us"</b>) and
                governs the collection, use, and disclosure of Personal Information by
                Fundever, whether such
                information is collected
                via our website located at www.fundever.com and the service available
                through it (the “Site”),
                other interaction we may
                have with you, or that we may obtain from third parties</p>
            <p>This Privacy Policy explains what Personal Information we collect, how we use
                and disclose that
                Personal Information,
                and the steps we take to secure that Personal Information. This Privacy
                Policy also explains how
                we can be contacted if
                a question arises about our privacy practices.
            </p>
            <p>This Privacy Policy does not apply to the practices of businesses, companies
                or other entities
                that Fundever does not
                manage or control. This Privacy Policy does not apply to information
                regarding corporations or
                other non-individuals.
            </p>
            <div className="border border-dark p-2 fw-bold">
                <p>By submitting Personal Information to us or by otherwise registering for,
                    accessing, browsing
                    and/or using the Site or
                    clicking the “agree” button below, you hereby consent to the collection,
                    use and disclosure of
                    Personal Information in
                    accordance with this Privacy Policy. If you disclose to us or post to
                    the Site any Personal
                    Information about others,
                    including your Clients, you also represent and warrant that you have
                    received all necessary
                    consents and that you have
                    the right to disclose to us and post that Personal Information in
                    accordance with all applicable
                    data and privacy
                    protection laws and regulations relating to privacy and the collection,
                    use and disclosure of
                    Personal Information in
                    all applicable jurisdictions and that our use of that Personal
                    Information will not violate any
                    such laws.
                </p>
                <p className="text-decoration-underline">If you do not agree with some or all of this Privacy
                    Policy and are not of 18
                    years or older,
                    do not register for,
                    access, or use the Site.</p>
                <p className="text-decoration-underline">You should print a copy of this Privacy Policy for
                    future reference.</p>

            </div>
            <p>Please read this Privacy Policy carefully so that you understand how we
                handle Personal
                Information. This Privacy Policy
                may also change. We will include a “last revised” date on the Privacy Policy
                as displayed on the
                Site. We strongly
                encourage you to refer back to the Privacy Policy periodically.
            </p>
            <h4>1. Definitions
            </h4>
            <p>For the purposes of this Privacy Policy, the following terms will have the
                following meanings:
            </p>
            <p><strong>"Aggregated Data"</strong> mean records which have been stripped of
                information
                potentially identifying
                individuals, or which
                have been manipulated or combined to provide generalized, statistical,
                aggregated, and anonymous
                information.
            </p>
            <p><strong>"Business Contact Information"</strong> means information to enable
                an individual at a
                place of business to be contacted and
                includes the business position, name or title, business address, business
                telephone number,
                business email address and
                business fax number of the individual.
            </p>
            <p><strong>"Client"</strong> means a client, whether an individual or a
                business, for whom you post
                a project looking
                for financing to the
                Site.
            </p>
            <p><strong>"Personal Information"</strong> information about an identifiable
                individual, but does
                not include
                Business Contact
                Information. Personal Information includes such things as a name, date of
                birth, gender, age,
                contact information
                (including home address, home telephone number and personal e-mail address),
                employment status,
                income, financial and
                credit information, mortgage profile, health information, customer profiles,
                ID numbers and any
                other data assigned to
                an individual.
            </p>
            <p><strong>"you"</strong>, <strong>"user"</strong>, and <strong>"your"</strong>
                means a user of the
                Site, whether registered or as a visitor, and
                whether an individual or a
                business, such as a mortgage broker, owner, developer, consortium, project
                sponsor, lender,
                borrower, or other user.
            </p>
            <h4>2. How We Collect Personal Information
            </h4>
            <p><strong>Information you give us.</strong> You may give us Personal
                Information when using the
                Site or by other
                interaction we may have
                with you (such as corresponding with us by phone, e-mail or otherwise). This
                includes Personal
                Information:
            </p>
            <ul>
                <li>You provide when you register to use the Site,
                </li>
                <li>You post to the Site, and</li>
                <li>You otherwise voluntarily give us.
                </li>
            </ul>
            <p><strong>Information We Automatically Collect.</strong> When you use the Site,
                a cookie may be
                placed within the memory of your internet
                access device. A cookie is a small piece of information that a website can
                store via your internet
                access device for
                later retrieval. We may use permanent cookies or server-side artifacts to
                help us track use of our
                services by users,
                including casual visitors to the Site, such as (without limitation) the
                number and frequency of
                visits to our pages and
                which parts of the Site are visited. Similarly, we may also collect
                information regarding the type
                of device, your
                operating system, the browser you use, your internet service provider, your
                domain name, your
                internet protocol (IP)
                address, your device identifier (UDID), the date and time that you accessed
                our service, the
                website that referred you
                to the Site, the web pages you requested and the subject of the ads you
                click or scroll over, page
                response times,
                download errors, length of visits to certain pages, page interaction
                information (such as
                scrolling, clicks, and
                mouse-overs), and methods used to browse away from the page. To collect this
                information, we use
                cookies, web beacons
                and similar technologies. You can control browser cookies through your
                browser’s settings. You may
                delete cookies or set
                your browser to alert you when cookies are being sent. If you reject all
                cookies, however, some
                areas of the Site may
                not function.
            </p>
            <h4>3. How We Use Personal Information
            </h4>
            <p><strong>Information you give us.</strong> We will use this Personal
                Information:
            </p>
            <ul>
                <li>To administer your account with us (if you register for one);
                </li>
                <li>To provide services via the Site, including but not limited posting
                    projects looking for
                    financing;
                </li>
                <li>To carry out our obligations arising from any contracts entered into
                    between you and us and to
                    provide you with the
                    information and services that you request from us;</li>
                <li>To communicate with you regarding your inquiries for information or to
                    update your account
                    status (if you register for
                    one), or other issues as they relate to your use of the Site;
                </li>
                <li>To ensure that content from the Site is presented in the most effective
                    manner for you and for
                    your computer;
                </li>
                <li>Other ways that are described in this Privacy Policy; and
                </li>
                <li>As required or permitted by law.
                </li>
            </ul>
            <p><strong>Information We Automatically Collect.</strong> We will use this
                information:
            </p>
            <ul>
                <li>To evaluate Site performance and service quality;
                </li>
                <li>To administer the Site and for internal operations, including security,
                    troubleshooting, data
                    analysis, testing,
                    research, statistical and survey purposes;
                </li>
                <li>To improve the Site to ensure that content is presented in the most
                    effective manner for you
                    and for your computer;
                </li>
                <li>Other ways that are described in this Privacy Policy; and
                </li>
                <li>As required or permitted by law.
                </li>
            </ul>
            <h4>4. Our Disclosure of Personal Information
            </h4>
            <p>Under certain circumstances, Fundever will disclose Personal Information:
            </p>
            <ul>
                <li>when you have consented to the disclosure (including through this
                    Privacy Policy);
                </li>
                <li>to fulfill the purpose for which the Personal Information was collected;
                </li>
                <li>when the services we are providing to you require us to give information
                    to third parties;
                </li>
                <li>if we engage a third party to provide services to us (like computer
                    back-up services or
                    archival file storage), in which
                    case we will use contract
                </li>
                <li>ual arrangements to protect Personal Information disclosed to them;</li>
                <li>in the event of a proposed or actual purchase, sale, merger,
                    amalgamation, or any other type
                    of acquisition,
                    disposition, or financing of all or any portion of Fundever or any of
                    the assets or shares of
                    Fundever, as permitted by
                    applicable law;
                </li>
                <li>other ways that are described in this Privacy Policy; and
                </li>
                <li>as required or permitted by law.
                </li>
            </ul>
            <h4>5. Protective and Legal Uses</h4>
            <p>We may use, share and disclose Personal Information for legal reasons as we
                believe necessary or
                appropriate, including:
            </p>
            <ul>
                <li>If a law, regulation, search warrant, subpoena or court order legally
                    requires or authorizes
                    us to do so;
                </li>
                <li>To detect, prevent or investigate security breaches or fraud, to protect
                    our business and to
                    maintain appropriate
                    records for internal administrative purposes;
                </li>
                <li>Where it is necessary to establish or collect fees or to allow us to
                    pursue available remedies
                    or limit the damages that
                    we may sustain;</li>
                <li>To enforce our contracts and policies;
                </li>
                <li>To protect our operations, rights, privacy, safety or property, and/or
                    that of our affiliates,
                    you or others; and
                </li>
                <li>As required or permitted by applicable law.
                </li>
            </ul>
            <h4>6. Promotional Electronic Messages
            </h4>
            <p>You may receive email, text or other promotional electronic messages from us
                if:
            </p>
            <ul>
                <li>You have provided your express consent to receive these messages;
                </li>
                <li>You have an existing or recently expired (within the previous two years)
                    registration to use
                    the Site;
                </li>
                <li>You have requested information from us about the Site, or registering to
                    use the Site, within
                    the previous six months;
                    or
                </li>
                <li>We have some other form of legally recognized basis for sending the
                    messages to you.
                </li>
            </ul>
            <p>Any promotional electronic message that you receive from us will identify us
                as the sender and
                provide for a means of
                unsubscribing from further electronic messages. Please note that if you
                unsubscribe to future
                e-mails or text messages,
                we nonetheless reserve the right to contact you (including my e-mail and
                other electronic
                messages) where we are
                required or permitted by law to do so.
            </p>
            <h4>7. Aggregated Data
            </h4>
            <p>We may use, mine, model, analyze, and match Personal Information and other
                data posted to or
                collected through the Site
                to generate Aggregated Data. We may use Aggregated Data for our internal
                purposes and for sharing
                with business
                partners, customers, advertisers, or as various published reports. We use
                Aggregated Data for
                purposes of marketing,
                planning, and our current and future operations and service offerings.
                Individual identity and
                Personal Information will
                be removed or kept anonymous in this Aggregated Data.
            </p>
            <h4>8. Third-Party Cookies and Information Used to Target Ads to You
            </h4>
            <p>We may share the information that you give us, and the information that we
                automatically collect
                about you, with others
                (including advertising service providers and networks) to serve you ads
                tailored to your interests
                or to tailor ads that
                may be served to you on the Site, as well as other websites and on social
                media networks. You may
                also see ads for
                Fundever on other websites and social media because we may participate in
                advertising networks.
                Advertising networks
                allow Fundever to target our advertising to you through demographic,
                behavioral and contextual
                means. These advertising
                networks track your online activities over time by collecting information
                through automated means,
                including through the
                use of cookies, web-beacons and other methods. Advertising networks use this
                information to show
                you advertisements that
                they believe are tailored to your interests. The information our advertising
                network vendors
                collect includes
                information about your visit to the Site as well as pages you have viewed,
                and the actions you
                have taken on the Sites.
                The use of cookies, web beacons, or similar technologies by content and
                advertising networks is
                subject to their own
                privacy policies, not ours.
            </p>
            <p>Various programs permit you to opt out of advertising programs that track
                your activities across
                multiple websites to
                deliver personalized advertising content to you. For more information about
                these programs and to
                opt-out using those
                programs, please visit:
            </p>
            <ul>
                <li>Digital Advertising Alliance of Canada Opt Out Page: <a
                    href="http://youradchoices.ca/understanding"
                    target="_blank" rel="noopener noreferrer">http://youradchoices.ca/understanding</a>
                    online advertising,
                </li>
                <li>NAI Opt Out Page: <a
                    href="http://www.networkadvertising.org/managing/opt_out.asp"
                    target="_blank" rel="noopener noreferrer">http://www.networkadvertising.org/managing/opt_out.asp</a>;
                </li>
                <li>Ad Choices Opt Out Page: <a href="http://www.aboutads.info/choices/"
                                                target="_blank" rel="noopener noreferrer">http://www.aboutads.info/choices/</a>.
                </li>
            </ul>
            <h4>9. Consent
            </h4>
            <p>By registering to use the Site, or by providing Personal Information to us,
                you voluntarily
                consent to the collection,
                use, and disclosure of Personal Information as specified in this Privacy
                Policy. Without limiting
                the foregoing, we may
                on occasion ask you to consent when we collect, use, or disclose Personal
                Information in specific
                circumstances, in
                which case we may ask for your consent in writing (including by electronic
                means) although in some
                circumstances we may
                accept your oral consent. Sometimes your consent will be implied through
                your conduct with us if
                the purpose of the
                collection, use or disclosure is obvious and you voluntarily provide the
                information. In addition,
                we may collect, use,
                and disclose Personal Information without your consent when we are required
                or permitted by law to
                do so.
            </p>
            <h4>10. Withdrawal of Consent
            </h4>
            <p>Individuals have the right to withdraw their consent to the collection, use,
                or disclosure of
                their Personal Information
                at any time, except where that withdrawal would frustrate the performance of
                a legal obligation by
                Fundever. Upon
                reasonable written notice given to Fundever, Personal Information held by
                Fundever that is
                identifiable to that
                individual will be removed from our records and a notice of the impact of
                that removal will be
                provided to the
                individual. Notwithstanding the foregoing, if you withdraw consent Fundever
                nonetheless reserves
                the right to retain,
                collect, use and disclose Personal Information without your consent where we
                are required or
                permitted by law to do so.
            </p>
            <h4>11. Retention of Personal Information
            </h4>
            <p>Personal Information will be retained in accordance with this Privacy Policy
                for as long as may
                be necessary or relevant
                for the purpose of collection, to resolve disputes, to enforce our
                contracts, or as may be
                required or permitted by law,
                after which time it will be made anonymous or destroyed unless you further
                consent to its
                continued retention.
            </p>
            <h4>12. Accuracy of Personal Information
            </h4>
            <p>In most instances, we rely on users of the Site to provide us with and to
                post to the Site
                Personal Information that is
                accurate and up-to-date for the purposes for which the Personal Information
                is to be used, as well
                as to notify us or
                update the Site concerning any changes to Personal Information provided by
                them.
            </p>
            <h4>13. How We Protect Your Personal Information
            </h4>
            <p>Fundever uses reasonable industry measures to protect against the
                unauthorized access,
                disclosure, modification or
                destruction of the Personal Information we collect. While we are committed
                to ensuring the
                security of the Personal
                Information, no protection measure can provide a 100% guarantee of security.
                Consequently, we do
                not warrant or
                guarantee the security of the Personal Information or of any text or email
                communications or
                information sent by you to
                us. If you wish to send us confidential information, please notify us first
                to make arrangements.
            </p>
            <h4>14. Where We Hold Personal Information
            </h4>
            <p>Personal Information collected by Fundever may be stored and processed
                outside of Canada,
                including in the United States
                and any other country worldwide in which Fundever or its service providers
                maintain their servers
                and facilities, and by
                using the Site, you consent to any such transfer of information outside of
                Canada. We will use
                reasonable measures
                according to Canadian law to ensure all Personal Information is protected,
                but cannot ensure that
                the laws of other
                countries will offer the same level of protection as Canadian laws. By
                submitting Personal
                Information to us, you hereby
                consent to the transmission, processing and/or storage of Personal
                Information outside of Canada.
                While Personal
                Information is stored or processed outside of Canada, the government, courts
                of law, and national
                security, enforcement
                or regulatory agencies of that jurisdiction may be able to obtain disclosure
                of Personal
                Information through the laws of
                that jurisdiction.</p>
            <h4>15. Links to Third Party Sites</h4>
            <p>The use of our Services may lead you to third party websites. Those
                organizations are separate
                and distinct from
                Fundever and have their own separate privacy policies. We are not
                responsible in any way for how
                any third party
                collects, uses or discloses Personal Information, so it is important to
                familiarize yourself with
                the privacy policies
                of these websites before providing Personal Information to them.
            </p>
            <h4>16. Review and Correction of Personal Information
            </h4>
            <p>Upon written request to contact@fundever.com and where the identity of the
                requester can be
                confirmed, you will be
                informed of the existence, use and disclosure of your Personal Information.
                Fundever provides an
                opportunity for
                individuals to correct the accuracy and completeness of their Personal
                Information and have it
                amended as appropriate.
                Please note that in some cases we</p>
            <p>may not be able to allow you to access or make changes to certain Personal
                Information in certain
                circumstances, for
                example if it contains Personal Information of other persons, or for legal
                reasons.
            </p>
            <h4>17. Contacting Us</h4>
            <p>Accountability with respect to Personal Information is important to Fundever.
                In the event that
                you have any questions
                (including how Personal Information is managed by Fundever or Fundever’s use
                of foreign service
                providers to process
                personal information), complaints or concerns about this Privacy Policy, or
                if you have reason to
                believe that we may
                have failed to adhere to it, please contact us by sending an email.
                Questions regarding your
                rights and responsibilities
                under this Privacy Policy can be directed to <a
                    href="mailto:contact@fundever.com">contact@fundever.com</a>.
            </p>
            <p>Last Revised: August 20th, 2020.</p>
        </div>
    );
};